import { data } from '../../svg/Thread/data';
import { makeIcon } from '../makeIcon';

export const Thread = makeIcon(data, 'thread', 'Thread');

export default Thread;
